import { isToday, isYesterday } from 'date-fns';
import {
  customDateFormatter,
  DefaultDateFormatter,
  getDefaultDateFormattingOptions,
  getDefaultTimeFormattingOptions,
  intl
} from '../../../lib';

const chatTimeFormatter = customDateFormatter({
  ...getDefaultTimeFormattingOptions(),
  second: undefined
});

const chatDateTimeFormatter = customDateFormatter({
  ...getDefaultDateFormattingOptions(),
  ...getDefaultTimeFormattingOptions(),
  second: undefined
});

export function formatChatMessageDate(date: string | Date): string {
  if (typeof date === 'string') {
    return date;
  }
  if (isToday(date)) {
    return chatTimeFormatter.formatDate(date);
  }
  if (isYesterday(date)) {
    return `${intl(
      'virtualvisithistoryportlet.view.list.yesterday'
    )} ${chatTimeFormatter.formatDate(date)}`;
  }
  return chatDateTimeFormatter.formatDate(date);
}

export function formatChatConversationDate(date: string | Date): string {
  if (typeof date === 'string') {
    return date;
  }
  if (isToday(date)) {
    return chatTimeFormatter.formatDate(date);
  }
  return DefaultDateFormatter.formatDate(date);
}
